import React from 'react';
import {
  Container,
  Grid,
  Typography,
  TextField,
  Button,
  Box,
  Paper,
  Stack,
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import { useLanguage } from '../context/LanguageContext';

const Contact = () => {
  const { language, translations } = useLanguage();

  const contactInfo = {
    address: {
      mr: 'किरकसाल ग्रामपंचायत कार्यालय, किरकसाल गाव, तालुका मान   , जिल्हा सातारा   , महाराष्ट्र - ४१०२०६ ',
      hi: 'किरकसाल ग्राम पंचायत कार्यालय, किरकसाल गांव, तालुका मान   , जिला सातारा   , महाराष्ट्र -४१०२०६ ',
      en: 'Kirksal Grampanchayat Office, Kirksal Village, Taluka Man, District Satara, Maharashtra - 411033'
    },
    phone: '+91 20 1234 5678',
    email: 'info@grampanchayatkirksal.com',
  };

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography variant="h3" component="h1" align="center" gutterBottom>
        {translations.contactUs[language]}
      </Typography>

      <Grid container spacing={4} sx={{ mt: 4 }}>
        {/* Contact Information */}
        <Grid item xs={12} md={4}>
          <Paper elevation={3} sx={{ p: 3, height: '100%' }}>
            <Stack spacing={4}>
              <Box>
                <Stack direction="row" spacing={2} alignItems="center">
                  <LocationOnIcon color="primary" />
                  <Typography variant="h6">
                    {translations.address[language]}
                  </Typography>
                </Stack>
                <Typography variant="body1" sx={{ mt: 1, pl: 4 }}>
                  {contactInfo.address[language]}
                </Typography>
              </Box>

              <Box>
                <Stack direction="row" spacing={2} alignItems="center">
                  <PhoneIcon color="primary" />
                  <Typography variant="h6">
                    {translations.phoneNumber[language]}
                  </Typography>
                </Stack>
                <Typography variant="body1" sx={{ mt: 1, pl: 4 }}>
                  {contactInfo.phone}
                </Typography>
              </Box>

              <Box>
                <Stack direction="row" spacing={2} alignItems="center">
                  <EmailIcon color="primary" />
                  <Typography variant="h6">
                    {translations.emailAddress[language]}
                  </Typography>
                </Stack>
                <Typography variant="body1" sx={{ mt: 1, pl: 4 }}>
                  {contactInfo.email}
                </Typography>
              </Box>
            </Stack>
          </Paper>
        </Grid>

        {/* Contact Form */}
        <Grid item xs={12} md={8}>
          <Paper elevation={3} sx={{ p: 3 }}>
            <Typography variant="h5" gutterBottom>
              {translations.sendMessage[language]}
            </Typography>
            <form>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label={language === 'mr' ? 'नाव' : language === 'hi' ? 'नाम' : 'Name'}
                    variant="outlined"
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label={translations.emailAddress[language]}
                    variant="outlined"
                    type="email"
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label={translations.phoneNumber[language]}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label={language === 'mr' ? 'विषय' : language === 'hi' ? 'विषय' : 'Subject'}
                    variant="outlined"
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label={language === 'mr' ? 'संदेश' : language === 'hi' ? 'संदेश' : 'Message'}
                    variant="outlined"
                    multiline
                    rows={4}
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button sx={{ backgroundColor: '#00106e' }}
                    variant="contained"
                    color="primary"
                    size="large"
                    fullWidth
                  >
                    {translations.submit[language]}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Contact;
